import { __awaiter, __generator } from "tslib";
import { getGraphDriveItemUrlModel } from '@office-start/graph-service';
import { createNewFile } from '@office-start/vroom-service';
import { getCreateRequestData } from '../util/getCreateRequestData';
import { isOneNoteNotebook } from '../util/isOneNoteNotebook';
import { launchContentWrapper } from './launchContentWrapper';
export function createOneDriveFile(app, candidate, options, startTime, template, enterpriseDriveId, shouldOpenInUIHost) {
    return __awaiter(this, void 0, void 0, function () {
        var newFileName, createRequestOptions, driveItem, urlModel, _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!options.componentContext || !options.sharedContext) {
                        return [2 /*return*/, Promise.resolve({ type: "Error" /* CreateDocumentResultType.Error */ })];
                    }
                    newFileName = "".concat(candidate.newDocName, ".").concat(candidate.fileExtension);
                    createRequestOptions = getCreateRequestData(options.componentContext);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, createNewFile(createRequestOptions, newFileName, false, app)];
                case 2:
                    driveItem = _a.sent();
                    if (!driveItem || isOneNoteNotebook(driveItem)) {
                        return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
                    }
                    return [4 /*yield*/, getGraphDriveItemUrlModel(driveItem, startTime, options.componentContext, options.sharedContext, template ? template.AssetId : '', options.templatesConfig, options.capabilities, options.referralParams)];
                case 3:
                    urlModel = _a.sent();
                    //TODO: should move this to getGraphDriveItemUrlModel?
                    if (shouldOpenInUIHost) {
                        if (driveItem.parentReference) {
                            urlModel.docId = driveItem.id;
                            urlModel.driveId = driveItem.parentReference.driveId;
                            urlModel.fileName = driveItem.name;
                        }
                    }
                    return [4 /*yield*/, launchContentWrapper(candidate, urlModel, options.targetTab, options.newDocLinkTarget, template, enterpriseDriveId)];
                case 4: 
                // createPromise.catch(errorMsg => {
                //     // Pass caught error to global handler to ensure that it is properly logged in case it is code error
                //     this.globalErrorHandler.handleError(errorMsg, ErrorId.foSs8);
                //     const graphError = errorMsg as GraphError;
                //     const code = graphError && graphError.error && graphError.error.code || '';
                //     if (code === '404') {
                //         onErrorFallback(ErrorDialogErrorType.OneDriveProvisioning);
                //     } else if (errorMsg && errorMsg.error && errorMsg.error.data === 'CAP_Error') {
                //         onErrorFallback(ErrorDialogErrorType.ConditionalAccessFallback);
                //     } else if (this.clientStartupConfigService.config.authType === AuthType.MSA && code === '403') {
                //         onErrorFallback(ErrorDialogErrorType.OneDriveDisabled);
                //     } else {
                //         onErrorFallback(ErrorDialogErrorType.Generic);
                //     }
                // });
                return [2 /*return*/, _a.sent()];
                case 5:
                    _error_1 = _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
            }
        });
    });
}
//# sourceMappingURL=createOneDriveFile.js.map